import { documentGeneratorApi } from "@/getinfo-api";
import { TemplateFileContextEnum } from "@/api-v2/document-generator/models/template-file";
import { TemplateFileCreateContextEnum } from "@/api-v2/document-generator/models/template-file-create";
import { Generate as IGenerate } from "@/api-v2/document-generator/models/generate";

const getDocumentGeneratorApiMethodByType = (
  context: TemplateFileContextEnum | TemplateFileCreateContextEnum
) => {
  if (context === TemplateFileContextEnum.Act)
    return documentGeneratorApi.Act.infoAct();
  if (context === TemplateFileContextEnum.Bill)
    return documentGeneratorApi.Bill.infoBill();
  if (context === TemplateFileContextEnum.Contract)
    return documentGeneratorApi.Contract.infoContract();
  if (context === TemplateFileContextEnum.EducationProtocol)
    return documentGeneratorApi.EducationProtocol.infoEducationProtocol();
  if (context === TemplateFileContextEnum.EnrollmentOrder)
    return documentGeneratorApi.EnrollmentOrder.infoEnrollmentOrder();
  if (context === TemplateFileContextEnum.ExpulsionOrder)
    return documentGeneratorApi.ExpulsionOrder.infoExpulsionOrder();
  if (context === TemplateFileContextEnum.FinalDocument)
    return documentGeneratorApi.FinalDocument.infoFinalDocument();
};

const generateDocumentApiMethodByType = (
  context: TemplateFileContextEnum | TemplateFileCreateContextEnum,
  id: string,
  generateParams: IGenerate
) => {
  if (context === TemplateFileContextEnum.Act)
    return documentGeneratorApi.Act.generateAct(id, generateParams);
  if (context === TemplateFileContextEnum.Bill)
    return documentGeneratorApi.Bill.generateBill(id, generateParams);
  if (context === TemplateFileContextEnum.Contract)
    return documentGeneratorApi.Contract.generateContract(id, generateParams);
  if (context === TemplateFileContextEnum.EducationProtocol)
    return documentGeneratorApi.EducationProtocol.generateEducationProtocol(
      id,
      generateParams
    );
  if (context === TemplateFileContextEnum.EnrollmentOrder)
    return documentGeneratorApi.EnrollmentOrder.generateEnrollmentOrder(
      id,
      generateParams
    );
  if (context === TemplateFileContextEnum.ExpulsionOrder)
    return documentGeneratorApi.ExpulsionOrder.generateExpulsionOrder(
      id,
      generateParams
    );
  if (context === TemplateFileContextEnum.FinalDocument)
    return documentGeneratorApi.FinalDocument.generateFinalDocument(
      id,
      generateParams
    );
};

const generateMultiplyDocumentApiMethodByType = (
  context: TemplateFileContextEnum | TemplateFileCreateContextEnum,
  ids: string[],
  generateParams: IGenerate
) => {
  if (context === TemplateFileContextEnum.Act)
    return documentGeneratorApi.Act.generateActMultiply(ids, generateParams);
  if (context === TemplateFileContextEnum.Bill)
    return documentGeneratorApi.Bill.generateBillMultiply(ids, generateParams);
  if (context === TemplateFileContextEnum.Contract)
    return documentGeneratorApi.Contract.generateContractMultiply(
      ids,
      generateParams
    );
  if (context === TemplateFileContextEnum.EducationProtocol)
    return documentGeneratorApi.EducationProtocol.generateEducationProtocolMultiply(
      ids,
      generateParams
    );
  if (context === TemplateFileContextEnum.EnrollmentOrder)
    return documentGeneratorApi.EnrollmentOrder.generateEnrollmentOrderMultiply(
      ids,
      generateParams
    );
  if (context === TemplateFileContextEnum.ExpulsionOrder)
    return documentGeneratorApi.ExpulsionOrder.generateExpulsionOrderMultiply(
      ids,
      generateParams
    );
  if (context === TemplateFileContextEnum.FinalDocument)
    return documentGeneratorApi.FinalDocument.generateFinalDocumentMultiply(
      ids,
      generateParams
    );
};

export {
  getDocumentGeneratorApiMethodByType,
  generateDocumentApiMethodByType,
  generateMultiplyDocumentApiMethodByType
};
